import { Heart } from "lucide-react";

export function Footer() {
  return (
    <footer className="w-full bg-white border-t">
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto text-center space-y-4">
          <p className="text-gray-600 text-xs">
            Economize tempo e aumente sua produtividade com prompts específicos para diversas áreas do Direito. 
            Desenvolvido para profissionais jurídicos.
          </p>
          <p className="text-sm text-gray-500">
            © 2026 LexPrompt. Todos os direitos reservados. Feito com{" "}
            <Heart className="inline-block w-4 h-4 text-red-500" /> por Decide Digital
            <br />
            CNPJ: 40.445.772/0001-51
          </p>
        </div>
      </div>
    </footer>
  );
}
